import { gql } from '@parkchirp/api-client';

export const GET_SUBLOTS = gql`
    query GetSublots(
        $facilityId: String!,
        $includePrimary: Boolean!
    ) {
        getSublots(
            facilityId: $facilityId,
            includePrimary: $includePrimary
        ) {
            id
            name
        }
    }
`;
